import React from 'react';
export const BodySelector = ({
  onSelect
}) => {
  return <div className="flex gap-4 justify-center" data-id="element-15">
      <button onClick={() => onSelect('Front')} className="relative group hover:scale-105 transition-transform" data-id="element-16">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eHeUcKDU7973FqnrUGbU3a/front.jpg" alt="Front body view" className="w-40 h-auto rounded-lg border-2 border-transparent group-hover:border-red-500" data-id="element-17" />
        <span className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-white px-3 py-1 rounded-full text-sm font-medium shadow-sm" data-id="element-18">
          Front
        </span>
      </button>
      <button onClick={() => onSelect('Back')} className="relative group hover:scale-105 transition-transform" data-id="element-19">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hQtvBHNgvx23ed1Kvbbu3U/back.jpg" alt="Back body view" className="w-40 h-auto rounded-lg border-2 border-transparent group-hover:border-red-500" data-id="element-20" />
        <span className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-white px-3 py-1 rounded-full text-sm font-medium shadow-sm" data-id="element-21">
          Back
        </span>
      </button>
    </div>;
};